import { X } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";

import { LABEL_COLORS } from "../constants";

import type { Label } from "../types";

type LabelTagProps = {
  label: Label;
  className?: string;
  size?: "sm" | "md";
} & (
  | { onClick?: () => void; onRemove?: never }
  | { onClick?: never; onRemove?: () => void }
);
export default function LabelTag({
  label,
  size = "md",
  onClick,
  className,
  onRemove,
}: LabelTagProps) {
  const { color, name, id } = label;
  const { tagVariant } = LABEL_COLORS[color];

  return (
    <Tag
      key={id}
      variant={tagVariant}
      className={className}
      size={size}
      asChild={!!onClick}
      rightIcon={
        onRemove && (
          <button
            aria-label={`remove label parameter ${name}`}
            type="button"
            onClick={onRemove}
          >
            <X />
          </button>
        )
      }
    >
      {onClick ? (
        <button type="button" onClick={onClick}>
          {name}
        </button>
      ) : (
        name
      )}
    </Tag>
  );
}
